export const LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM = "LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM";
export const LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM_SUCCESS = "LOAD_SAVED_FAST_TRACK_PIT_PUP_MEDICAL_FORM_SUCCESS";

export const AUTO_SAVE_FAST_TRACK_PIT_PUP_MEDICAL_FORM = "AUTO_SAVE_FAST_TRACK_PIT_PUP_MEDICAL_FORM";

export const SUBMIT_FAST_TRACK_PIT_PUP_MEDICAL_FORM = "SUBMIT_FAST_TRACK_PIT_PUP_MEDICAL_FORM";
